//BootstrapCalendar
export const BOOTSTRAP_CALENDER = [
  {
    id: 1,
    labelText: "Date and time",
    type: "datetime-local",
    value: "2023-05-03T18:45:00",
  },
  {
    id: 2,
    labelText: "Date",
    type: "date",
    value: "2023-05-01",
  },
  {
    id: 3,
    labelText: "Month",
    type: "month",
    value: "2023-01",
  },
  {
    id: 4,
    labelText: "Week",
    type: "week",
    value: "2023-W09",
  },
  {
    id: 5,
    labelText: "Time",
    type: "time",
    value: "21:45:00",
  },
];

//Default Touchspins
export const TOUCHSPIN_DATA = [
  {
    text: "Use the ",
    code: ".decrement-touchspin ",
  },
  {
    text: "and ",
    code: ".increment-touchspin ",
  },
  {
    text: "class.",
  },
];

//Custom switch
export const CUSTOM_SWIRCH = [
  {
    text: "A switch has the markup of a custom checkbox but uses the .form-switch class to render a ",
    code: "toggle switch.",
  },
];

export const CUSTOM_SWIRCH_LIST = [
  {
    id: 1,
    sm: "6",
    item: ["primary", "secondary", "success", "danger", "warning", "info", "dark"],
  },
  {
    id: 2,
    sm: "6",
    cardClass: "radius-none",
    formClass: "default-square",
    item: ["primary", "secondary", "success", "danger", "warning", "info", "dark"],
  },
  {
    id: 3,
    cardClass: "common-flex",
    disabled: true,
    item: ["primary", "secondary", "success", "danger", "warning", "info", "dark"],
  },
];

//Icons Switchs
export const ICON_SWITCH = [
  {
    text: "Use the ",
    code: ".switch-state ",
  },
  {
    text: "and ",
    code: "icon-state ",
  },
  {
    text: "through defined icons switches.",
  },
];

export const ICON_SWITCH_LIST = [
  {
    color: "primary",
    text: "Primary Switch",
  },
  {
    color: "secondary",
    text: "Secondary Switch",
  },
  {
    color: "success",
    text: "Success Switch",
  },
  {
    color: "danger",
    text: "Danger Switch",
  },
  {
    color: "warning",
    text: "Warning Switch",
  },
  {
    color: "info",
    text: "Info Switch",
  },
  {
    color: "dark",
    text: "Dark Switch",
  },
];

//Unchecked Switchs
export const UNCHECKED_SWITCH = [
  {
    text: "Use the ",
    code: ".bg-*",
  },
  {
    text: " class through created default switches. ",
  },
];

export const UNCHECKED_SWITCH_LIST = [
  {
    color: "primary",
    text: "Unchecked Primary Switch",
  },
  {
    color: "secondary",
    text: "Unchecked Secondary Switch",
  },
  {
    color: "success",
    text: "Unchecked Success Switch",
  },
  {
    color: "danger",
    text: "Unchecked Danger Switch",
  },
  {
    color: "warning",
    text: "Unchecked Warning Switch",
  },
  {
    color: "info",
    text: "Unchecked Info Switch",
  },
  {
    color: "dark",
    text: "Unchecked Dark Switch",
  },
];

//Borders With Icon
export const BORDER_ICON_SWITCH = [
  {
    text: "Use the ",
    code: ".switch-state ",
  },
  {
    text: "and ",
    code: "icon-state ",
  },
  {
    text: " class through created outline and icons. ",
  },
];

export const BORDER_ICON_SWITCH_LIST = [
  {
    color: "primary",
    text: "Bordered Primary Switch",
  },
  {
    color: "secondary",
    text: "Bordered Secondary Switch",
  },
  {
    color: "success",
    text: "Bordered Success Switch",
  },
  {
    color: "danger",
    text: "Bordered Danger Switch",
  },
  {
    color: "warning",
    text: "Bordered Warning Switch",
  },
  {
    color: "info",
    text: "Bordered Info Switch",
  },
  {
    color: "dark",
    text: "Bordered Dark Switch",
  },
];

//Disabled Outline Switchs
export const DISABLED_OUTLINE_SWITCH = [
  {
    text: "Use the ",
    code: ".switch-outline ",
  },
  {
    text: " class through created outline. ",
  },
];

export const DISABLED_OUTLINE_SWITCH_LIST = ["primary", "secondary", "success", "danger", "warning", "info", "dark"];

//Variation Of Switche
export const VARIATION_SWITCH = [
  {
    text: "Use the ",
    code: ".tgl-skewed/tgl-flip",
  },
  {
    text: " class through created variations. ",
  },
];

export const VARIATION_SWITCH_LIST = [
  {
    id: "",
    inputClass: "",
  },
];

export const VARIATION_SWITCH_LIST_1 = [
  {
    id: "cb3",
    inputClass: "tgl-skewed",
    text: "Skewed",
    offData:"OFF",
    onData:"ON"
  },
  {
    id: "cb5",
    inputClass: "tgl-flip",
    text: "Flip",
    offData:"Nope",
    onData:"Yeah!"
  },
];

export const VARIATION_SWITCH_LIST_2 = [
  {
    inputClass: "tgl-skewed",
    text: "Checked",
    flexClass: "icon-state",
    color: "warning",
  },
  {
    inputClass: "tgl-flip",
    text: "Flat",
    color: "success",
  },
];

//Switch Sizing
export const SWITCH_SIZING = [
  {
    text: "Use the ",
    code: ".switch-sm ",
  },
  {
    text: "and ",
    code: ".switch-lg ",
  },
  {
    text: "class through defined switch sizing.",
  },
];

export const SWITCH_SIZING_LIST = [
  {
    label: "Small Size",
    flexClass: "switch-sm",
    defaultChecked: true,
  },
  {
    label: "Small Size Unhecked",
    flexClass: "switch-sm",
  },
  {
    label: "Normal Size",
    defaultChecked: true,
  },
  {
    label: "Normal Unhecked",
  },
  {
    label: "Disabled State",
    disabled: true,
  },
  {
    label: "Large Size",
    flexClass: "switch-lg",
    defaultChecked: true,
  },
  {
    label: "Large Unhecked",
    flexClass: "switch-lg",
  },
  {
    label: "Disabled",
    flexClass: "switch-lg",
    disabled: true,
  },
];

//Switch With Icon
export const SWITCH_WITH_ICON = [
  {
    text: "Use the ",
    code: ".icon-state",
  },
  {
    text: " class through visible icons in switches",
  },
];

export const SWITCH_WITH_ICON_LIST = [
  {
    label: "Small Size",
    flexClass: "switch-sm",
    defaultChecked: true,
  },
  {
    label: "Small Size Unhecked",
    flexClass: "switch-sm",
  },
  {
    label: "Normal Size",
    defaultChecked: true,
  },
  {
    label: "Normal Unhecked",
  },
  {
    label: "Disabled State",
    disabled: true,
  },
  {
    label: "Large Size",
    flexClass: "switch-lg",
    defaultChecked: true,
  },
  {
    label: "Large Unhecked",
    flexClass: "switch-lg",
  },
  {
    label: "Disabled",
    flexClass: "switch-lg",
    disabled: true,
  },
];

//Touchspin
export const  DEFAULT_TOUCHSPIN_DATA = [
  { id: 1, value: 0, color: "primary" },
  { id: 2, value: 2, color: "secondary" },
  { id: 3, value: 1, color: "success" },
  { id: 4, value: 8, color: "danger" },
  { id: 5, value: 3, color: "warning" },
  { id: 6, value: 9, color: "info" },
  { id: 7, value: 4, color: "dark" },
];

//Basic Typeahead
export const BASIC_TYPEAHEAD = [
  {
    text: "This is the simple demo for Typeahead.",
  },
];

export const STATE_OF_USA = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

//Prefetch
export const PREFETCH = [
  {
    text: "Prefetched data is fetched and processed on initialization",
  },
];

export const COUNTRY_LIST = [
  "Andorra",
  "United Arab Emirates",
  "Afghanistan",
  "Antigua and Barbuda",
  "Anguilla",
  "Albania",
  "Armenia",
  "Angola",
  "Antarctica",
  "Argentina",
  "American Samoa",
  "Austria",
  "Australia",
  "Aruba",
  "Åland",
  "Azerbaijan",
  "Bosnia and Herzegovina",
  "Barbados",
  "Bangladesh",
  "Belgium",
  "Burkina Faso",
  "Bulgaria",
  "Bahrain",
  "Burundi",
  "Benin",
  "Saint Barthélemy",
  "Bermuda",
  "Brunei",
  "Bolivia",
  "Bonaire",
  "Brazil",
  "Bahamas",
  "Bhutan",
  "Bouvet Island",
  "Botswana",
  "Belarus",
  "Belize",
  "Canada",
  "Cocos [Keeling] Islands",
  "Congo",
  "Central African Republic",
  "Republic of the Congo",
  "Switzerland",
  "Ivory Coast",
  "Cook Islands",
  "Chile",
  "Cameroon",
  "China",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Cape Verde",
  "Curacao",
  "Christmas Island",
  "Cyprus",
  "Czechia",
  "Germany",
  "Djibouti",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "Algeria",
  "Ecuador",
  "Estonia",
  "Egypt",
  "Western Sahara",
  "Eritrea",
  "Spain",
  "Ethiopia",
  "Finland",
  "Fiji",
  "Falkland Islands",
  "Micronesia",
  "Faroe Islands",
  "France",
  "Gabon",
  "United Kingdom",
  "Grenada",
  "Georgia",
  "French Guiana",
  "Guernsey",
  "Ghana",
  "Gibraltar",
  "Greenland",
  "Gambia",
  "Guinea",
  "Guadeloupe",
  "Equatorial Guinea",
  "Greece",
  "South Georgia and the South Sandwich Islands",
  "Guatemala",
  "Guam",
  "Guinea-Bissau",
  "Guyana",
  "Hong Kong",
  "Heard Island and McDonald Islands",
  "Honduras",
  "Croatia",
  "Haiti",
  "Hungary",
  "Indonesia",
  "Ireland",
  "Israel",
  "Isle of Man",
  "India",
  "British Indian Ocean Territory",
  "Iraq",
  "Iran",
  "Iceland",
  "Italy",
  "Jersey",
  "Jamaica",
  "Jordan",
  "Japan",
  "Kenya",
  "Kyrgyzstan",
  "Cambodia",
  "Kiribati",
  "Comoros",
  "Saint Kitts and Nevis",
  "North Korea",
  "South Korea",
  "Kuwait",
  "Cayman Islands",
  "Kazakhstan",
  "Laos",
  "Lebanon",
  "Saint Lucia",
  "Liechtenstein",
  "Sri Lanka",
  "Liberia",
  "Lesotho",
  "Lithuania",
  "Luxembourg",
  "Latvia",
  "Libya",
  "Morocco",
  "Monaco",
  "Moldova",
  "Montenegro",
  "Saint Martin",
  "Madagascar",
  "Marshall Islands",
  "Macedonia",
  "Mali",
  "Myanmar [Burma]",
  "Mongolia",
  "Macao",
  "Northern Mariana Islands",
  "Martinique",
  "Mauritania",
  "Montserrat",
  "Malta",
  "Mauritius",
  "Maldives",
  "Malawi",
  "Mexico",
  "Malaysia",
  "Mozambique",
  "Namibia",
  "New Caledonia",
  "Niger",
  "Norfolk Island",
  "Nigeria",
  "Nicaragua",
  "Netherlands",
  "Norway",
  "Nepal",
  "Nauru",
  "Niue",
  "New Zealand",
  "Oman",
  "Panama",
  "Peru",
  "French Polynesia",
  "Papua New Guinea",
  "Philippines",
  "Pakistan",
  "Poland",
  "Saint Pierre and Miquelon",
  "Pitcairn Islands",
  "Puerto Rico",
  "Palestine",
  "Portugal",
  "Palau",
  "Paraguay",
  "Qatar",
  "Réunion",
  "Romania",
  "Serbia",
  "Russia",
  "Rwanda",
  "Saudi Arabia",
  "Solomon Islands",
  "Seychelles",
  "Sudan",
  "Sweden",
  "Singapore",
  "Saint Helena",
  "Slovenia",
  "Svalbard and Jan Mayen",
  "Slovakia",
  "Sierra Leone",
  "San Marino",
  "Senegal",
  "Somalia",
  "Suriname",
  "South Sudan",
  "São Tomé and Príncipe",
  "El Salvador",
  "Sint Maarten",
  "Syria",
  "Swaziland",
  "Turks and Caicos Islands",
  "Chad",
  "French Southern Territories",
  "Togo",
  "Thailand",
  "Tajikistan",
  "Tokelau",
  "East Timor",
  "Turkmenistan",
  "Tunisia",
  "Tonga",
  "Turkey",
  "Trinidad and Tobago",
  "Tuvalu",
  "Taiwan",
  "Tanzania",
  "Ukraine",
  "Uganda",
  "U.S. Minor Outlying Islands",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vatican City",
  "Saint Vincent and the Grenadines",
  "Venezuela",
  "British Virgin Islands",
  "U.S. Virgin Islands",
  "Vietnam",
  "Vanuatu",
  "Wallis and Futuna",
  "Samoa",
  "Kosovo",
  "Yemen",
  "Mayotte",
  "South Africa",
  "Zambia",
  "Zimbabwe",
];

//Bloodhound (Suggestion Engine)
export const BLOODHOUND = [
  {
    text: "Bloodhound offers advanced functionalities such as prefetching and backfilling with remote data.",
  },
];

//Remote typeAhead Heading
export const REMOTE_TYPEAHEAD_HEADING = [
  {
    text: "Remote data is only used when the data provided by local and prefetch is insufficient",
  },
];

export const MOVIE_LIST = [
  "Around the World in 80 Days",
  "All Quiet on the Western Front",
  "Gentleman's Agreement",
  "All the Kings Men",
  "All About Eve",
  "An American in Paris",
  "The Apartment",
  "The Broadway Melody",
  "Mutiny on the Bounty",
  "The Best Years of Our Lives",
  "The Bridge on the River Kwai",
  "Ben-Hur",
  "Cimarron",
  "Cavalcade",
  "You Can't Take It with You",
  "Casablanca",
  "The Life of Emile Zola",
  "The Greatest Show on Earth",
  "From Here to Eternity",
  "Grand Hotel",
  "The Great Ziegfeld",
  "Gone with the Wind",
  "How Green Was My Valley",
  "Going My Way",
  "Gigi",
  "It Happened One Night",
  "Hamlet",
  "Mrs. Miniver",
  "Marty",
  "Rebecca",
  "Wings",
];

//Custom templates
export const CUSTOM_TEMPLATES = [
  {
    text: "Custom templates give you full control over how suggestions get rendered",
  },
];

export const OSCAR_WINNER = [
  "West Side Story",
  "Lawrence of Arabia",
  "Tom Jones",
  "My Fair Lady",
  "The Sound of Music",
  "A Man for All Seasons",
  "In the Heat of the Night",
  "Oliver!",
  "Midnight Cowboy",
  "Patton",
  "The French Connection",
  "The Godfather",
  "The Sting",
  "The Godfather Part II",
  "One Flew over the Cuckoo's Nest",
  "Rocky",
  "Annie Hall",
  "The Deer Hunter",
  "Kramer vs. Kramer",
  "Ordinary People",
  "Chariots of Fire",
  "Gandhi",
  "Terms of Endearment",
  "Amadeus",
  "Out of Africa",
  "Platoon",
  "The Last Emperor",
  "Rain Man",
  "Driving Miss Daisy",
  "Dances With Wolves",
  "The Silence of the Lambs",
  "Unforgiven",
  "Schindler’s List",
  "Forrest Gump",
  "Braveheart",
  "The English Patient",
  "Titanic",
  "Shakespeare in Love",
  "American Beauty",
  "Gladiator",
  "A Beautiful Mind",
  "Chicago",
  "The Lord of the Rings: The Return of the King",
  "Million Dollar Baby",
  "Crash",
  "The Departed",
  "No Country for Old Men",
  "Slumdog Millionaire",
  "The Hurt Locker",
  "The King's Speech",
  "The Artist",
  "Argo",
];

//Multiple sections with headers
export const MULTIPLE_SECTIONS_WITH_HEADERS = [
  {
    text: "Two datasets that are prefetched, stored, and searched on the client. Highlighting is enabled.",
  },
];

export const MULTI_WITH_HEADER = [
  { name: "NBA Teams", header: true },
  { name: "Boston Celtics" },
  { name: "Dallas Mavericks" },
  { name: "Brooklyn Nets" },
  { name: "Houston Rockets" },
  { name: "New York Knicks" },
  { name: "Memphis Grizzlies" },
  { name: "Philadelphia 76ers" },
  { name: "New Orleans Hornets" },
  { name: "Toronto Raptors" },
  { name: "San Antonio Spurs" },
  { name: "Chicago Bulls" },
  { name: "Denver Nuggets" },
  { name: "Cleveland Cavaliers" },
  { name: "Minnesota Timberwolves" },
  { name: "Detroit Pistons" },
  { name: "Portland Trail Blazers" },
  { name: "Indiana Pacers" },
  { name: "Oklahoma City Thunder" },
  { name: "Milwaukee Bucks" },
  { name: "Utah Jazz" },
  { name: "Atlanta Hawks" },
  { name: "Golden State Warriors" },
  { name: "Charlotte Bobcats" },
  { name: "Los Angeles Clippers" },
  { name: "Miami Heat" },
  { name: "Los Angeles Lakers" },
  { name: "Orlando Magic" },
  { name: "Phoenix Suns" },
  { name: "Washington Wizards" },
  { name: "Sacramento King" },
  { name: "", divider: true },
  { name: "NHL Teams", header: true },
  { name: "Boston Celtics" },
  { name: "Dallas Mavericks" },
  { name: "Brooklyn Nets" },
  { name: "Houston Rockets" },
  { name: "New York Knicks" },
  { name: "Memphis Grizzlies" },
  { name: "Philadelphia 76ers" },
  { name: "New Orleans Hornets" },
  { name: "Toronto Raptors" },
  { name: "San Antonio Spurs" },
  { name: "Chicago Bulls" },
  { name: "Denver Nuggets" },
  { name: "Cleveland Cavaliers" },
  { name: "Minnesota Timberwolves" },
  { name: "Detroit Pistons" },
  { name: "Portland Trail Blazers" },
  { name: "Indiana Pacers" },
  { name: "Oklahoma City Thunder" },
  { name: "Milwaukee Bucks" },
  { name: "Utah Jazz" },
  { name: "Atlanta Hawks" },
  { name: "Golden State Warriors" },
  { name: "Charlotte Bobcats" },
  { name: "Los Angeles Clippers" },
  { name: "Miami Heat" },
  { name: "Los Angeles Lakers" },
  { name: "Orlando Magic" },
  { name: "Phoenix Suns" },
  { name: "Washington Wizards" },
  { name: "Sacramento King" },
];

//Scrollable Dropdown Menu
export const SCROLLABLE_DROPDOWN = [
  {
    text: "Dataset shows in scrollable dropdown menu.",
  },
];

//Dataset shows in Right Side.
export const RTL_SUPPORT = [
  {
    text: "Dataset shows in Right Side.",
  },
];